import airlineRetailingTechniqueBlacklist from '../useAirlineRetailingTechniquesAllowed/airlineRetailingTechniqueBlacklist';
import { calculateAirlineCampaignData } from 'clientState/hooks/useAirlineSteering';

const getHasCardDecoration = (
  itinerary: any,
  isDesktop: boolean,
  trackingInfo: { returningUserDeviceId: string | undefined }
) => {
  const hasRetailingTechniques = () => {
    const { legs } = itinerary || {};
    const airlines = legs?.map((legs) =>
      legs.segments.map((segment) => segment.carrier.id)
    );

    return !airlines?.flat().some((airline) => {
      return airlineRetailingTechniqueBlacklist.includes(airline);
    });
  };

  const hasAirlineCampaignData = calculateAirlineCampaignData(
    trackingInfo,
    itinerary || {}
  );

  const hasPrimeDayCondition = () => {
    const { primeDayFareType } =
      itinerary?.campaignConfig?.primeDayConfig || {};

    if (hasAirlineCampaignData) {
      return primeDayFareType && primeDayFareType === 'GOLD';
    } else {
      return false;
    }
  };

  if (!itinerary) {
    return {
      hasDecoration: false,
      decorationType: 'default',
    };
  }

  return {
    hasDecoration:
      itinerary?.highlightedType === 'recommended' && hasRetailingTechniques()
        ? true
        : isDesktop && // we only have header label decorations for recommended type on mobile
          itinerary?.highlightedType !== 'default' &&
          hasRetailingTechniques() &&
          !hasPrimeDayCondition(),
    decorationType: itinerary?.highlightedType,
  };
};

export default getHasCardDecoration;
